import { z } from "zod";
import { createEntity } from "@coltorapps/builder";

import { widthAttribute } from "../../attributes/width/definition";
import { labelAttribute } from "../../attributes/label/definition";
import { defaultBooleanValueAttribute } from "../../attributes/default-boolean-value/definition";
import { requiredAttribute } from "../../attributes/required/definition";
import { EntityKey } from "@/types/form-builder";
import { nameAttribute } from "../../attributes/name/definition";
import { flowTypeAttribute } from "../../attributes/flow-type/definition";
import { validatorAttribute } from "../../attributes/validator/definition";
import { disabledAttribute } from "../../attributes/disabled/definition";
import { readonlyAttribute } from "../../attributes/readonly/definition";
import { hideAttribute } from "../../attributes/hide/definition";

function resolveDefaultBoolean(defaultValue: unknown): boolean {
  if (typeof defaultValue === "boolean") {
    return defaultValue;
  }

  if (
    defaultValue &&
    typeof defaultValue === "object" &&
    "value" in defaultValue
  ) {
    const value = (defaultValue as { value?: unknown }).value;
    if (typeof value === "boolean") {
      return value;
    }
  }

  return true;
}

export const toggleFieldEntity = createEntity({
  name: EntityKey.toggleField,
  attributes: [
    widthAttribute,
    nameAttribute,
    labelAttribute,
    defaultBooleanValueAttribute,
    requiredAttribute,
    flowTypeAttribute,
    validatorAttribute,
    disabledAttribute,
    readonlyAttribute,
    hideAttribute,
  ],
  validate(value, context): boolean {
    if (context.entity.attributes.required) {
      return z.literal(true).parse(value);
    }

    return z.boolean().parse(value);
  },
  defaultValue(context): boolean {
    return resolveDefaultBoolean(context.entity.attributes.defaultValue);
  },
});
